import { render, staticRenderFns } from "./EditAttivitaManuale.vue?vue&type=template&id=4140e819"
import script from "./EditAttivitaManuale.vue?vue&type=script&lang=js"
export * from "./EditAttivitaManuale.vue?vue&type=script&lang=js"
import style0 from "./EditAttivitaManuale.vue?vue&type=style&index=0&id=4140e819&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports